module.exports = __webpack_public_path__ + "static/media/lock.ef7f67ad.svg";